import React, {useState} from 'react';
import { Mixpanel } from '../redux/Mixpanel';

import { PasswordChangeMutation } from '../api/graphql/queries/authentication';
import graphqlClient from '../api/axios_interceptor';
import { showLoading, showCustomError, showCustomMessage } from '../redux/actions';
import { connect } from 'react-redux';
import { colorTheme } from '../utils/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { arrowBack, eye, eyeOff } from 'ionicons/icons';
import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonList, IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { Container, FormFeedback } from 'reactstrap';

const mapDispatchToProps={
    showLoading,
    showCustomError,
    showCustomMessage
}

const mapStateToProps = state => {
    return {};
}


const fields = ["oldPassword", "newPassword1", "newPassword2", "nonFieldErrors"];
let initialErrorState = {
    oldPassword: "",
    newPassword1: "",
    newPassword2: "",
    nonFieldErrors: ""
}

function ChangePassword({showLoading, showCustomError, showCustomMessage}){

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword1, setNewPassword1] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showPasswordOne, setShowPasswordOne] = useState(false);
    const [showPasswordTwo, setShowPasswordTwo] = useState(false);
    const [errors, setErrors] = useState(initialErrorState);

    const history = useHistory();

    // Mixpanel.track("Change password page: mounted");

    const validatePasswordStrength = (text) => {
        let newErrors = { ...errors };
        if (text.detail.value.length < 8){
            newErrors.newPassword1 = "Ensure your password is atleast 8 characters long";
        }else{
            if (/^[a-zA-Z]+$/.test(text.detail.value) || !isNaN(text.detail.value) ) {
                newErrors.newPassword1 = "Ensure your password is a combination of letters and numbers";
            }else{
                //Clear all error states
                newErrors.oldPassword = "";
                newErrors.newPassword1 = "";
                newErrors.newPassword2 = "";
            }
        }
        setNewPassword1(text.detail.value);
        setErrors(newErrors);
    }

    const getState = () => {
        return {
            newPassword1: newPassword1,
            newPassword2: newPassword2,
            oldPassword: oldPassword
        }
    }

    const validatePasswordEquality = (text) => {
        let newErrors = { ...errors };
        if (newPassword1 !== text.detail.value){
            newErrors.newPassword2 = "The passwords you have entered do not match";
        }
        else{
            newErrors.newPassword1 = "";
            newErrors.newPassword2 = "";
        }
        setNewPassword2(text.detail.value);
        setErrors(newErrors);
    }

    const validateAndChangePassword = (event) => {
        try{
            event.preventDefault();
            showLoading(true);
            let newErrors = { ...errors };
            if (newPassword1 === '' || newPassword2 === '' || oldPassword === '') {
                showLoading(false);
                const state = getState();
                for(let field of fields){
                    if(state[field] == ""){
                        newErrors[field] = "This field is required";
                    }
                }
                setErrors(newErrors);

            } else {
                if (newPassword1 === newPassword2) {
                    ChangeThePassword();
                } else {
                    showLoading(false);
                    newErrors.newPassword2 = "The passwords you have entered do not match.";
                }
            }
        }catch (error) {
            console.error(error);
        }
    }
// Here. Look for the newPassword1 change query and continue from here
    const ChangeThePassword = async () => {
        try {
            await graphqlClient({
                data: {
                  query: PasswordChangeMutation({oldPassword, newPassword1, newPassword2})
                }
              }).then((queryResult) => {
                findNextStep(queryResult);
              });

        } catch (error) {
            console.error(error);
            showLoading(false);
            showCustomError(error);
        }
    }

    const findNextStep = (queryResult) =>{
        showLoading(false);
        try{
            if (queryResult.data.data.passwordChange.success === false) {
                let newErrors = { ...errors };
                const queryErrors = queryResult.data.data.passwordChange.errors;
                for(let field of fields){
                    if(queryErrors.hasOwnProperty(field)){
                        newErrors[field] = queryErrors[field].map(e => e.message).join("\n");
                    }
                }
                showCustomError("Password change failed");
                Mixpanel.track("Change password page: Unsuccessful change");
                setErrors(newErrors);
            } else {
                showCustomMessage("","Password changed successfully");
                setErrors(initialErrorState);
                Mixpanel.track("Change password page: Successful change");
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleBackButton = () => {
        history.goBack();
    }

    let displayButton = true;
    displayButton =  Capacitor.getPlatform() === 'web';

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Change Password</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonGrid>
                    {/* START Header */}
                    {displayButton && (<IonRow className="d-flex justify-content-start">
                        <IonCol size="12" sizeLg="9" className="mb-3">
                            <IonButton
                                color="primary"
                                className="mx-2"
                                style={{ borderColor: colorTheme["primary"]["700"], color: 'white' }}
                                onClick={handleBackButton}
                                data-testid="mpesaBackButton"
                            >
                                <IonIcon slot="start" icon={arrowBack} />
                                Back
                            </IonButton>
                        </IonCol>
                    </IonRow>)}
                    <Container>
                    <IonRow className="d-flex justify-content-center">
                        <IonCol size="12" sizeLg="9" className="mb-3">
                            <IonRow className="d-flex align-items-center justify-content-center">
                                <IonImg
                                    src="images/logos/BOMAHUT-purple.svg"
                                    style={{ maxWidth: '300px', maxHeight: '75px' }}
                                    className="m-2"
                                    alt="Bomahut logo"
                                />
                            </IonRow>
                            {/* END Header */}
                            {/* START Form */}
                            <form className="mb-3" onSubmit={validateAndChangePassword}>
                                <IonList>
                                <IonItem style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                                    <IonInput
                                        name="oldPassword"
                                        id='oldPassword'
                                        placeholder='Enter Old Password'
                                        type={showOldPassword ? "text" : "password"}
                                        value={oldPassword}
                                        onIonInput={(e) => setOldPassword(e.detail.value)}
                                        label='Old Password'
                                        labelPlacement='floating'
                                        required
                                    />
                                    <IonIcon size='small' className='pt-3 px-0' onClick={() => setShowOldPassword(!showOldPassword)} fill="clear" slot="end" icon={showOldPassword ? eye : eyeOff} />
                                    {errors.oldPassword && <IonText color="danger">{errors.oldPassword}</IonText>}
                                </IonItem>
                                <IonItem style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                                    <IonInput
                                        name="newPassword1"
                                        id='newPassword1'
                                        placeholder='Enter New Password'
                                        type={showPasswordOne ? "text" : "password"}
                                        value={newPassword1}
                                        onIonInput={(e) => validatePasswordStrength(e)}
                                        label='New Password'
                                        labelPlacement='floating'
                                        required
                                    />
                                    <IonIcon size='small' className='pt-3 px-0' onClick={() => setShowPasswordOne(!showPasswordOne)} fill="clear" slot="end" icon={showPasswordOne ? eye : eyeOff} />
                                    {errors.newPassword1 && <IonText color="danger">{errors.newPassword1}</IonText>}
                                    <FormFeedback>The password should be unique and be at least 8 characters.</FormFeedback>
                                </IonItem>
                                <IonItem style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                                    <IonInput
                                        name="newPassword2"
                                        id='newPassword2'
                                        placeholder='Confirm New Password'
                                        type={showPasswordTwo ? "text" : "password"}
                                        value={newPassword2}
                                        onIonInput={(e) => validatePasswordEquality(e)}
                                        label='Confirm New Password'
                                        labelPlacement='floating'
                                        required
                                    />
                                    <IonIcon size='small' className='pt-3 px-0' onClick={() => setShowPasswordTwo(!showPasswordTwo)} fill="clear" slot="end" icon={showPasswordTwo ? eye : eyeOff} />
                                    {errors.newPassword2 && <IonText color="danger">{errors.newPassword2}</IonText>}
                                </IonItem>
                                </IonList>
                                <IonButton
                                    expand="block"
                                    type="submit"
                                    className="ion-margin-top"
                                    style={{ backgroundColor: colorTheme["primary"]["700"] }}
                                >
                                    Change Password
                                </IonButton>
                            </form>
                            {/* END Form */}
                        </IonCol>
                    </IonRow>
                    </Container>
                    {displayButton && (<IonRow className="d-flex justify-content-start">
                        <IonCol size="12" sizeLg="9" className="mb-3">
                            <IonButton
                                color="primary"
                                className="mx-2"
                                onClick={handleBackButton}
                                data-testid="mpesaBackButton"
                            >
                                <IonIcon slot="start" icon={arrowBack} />
                                Back
                            </IonButton>
                        </IonCol>
                    </IonRow>)}
                </IonGrid>
            </IonContent>
        </IonPage>
    );

}

export default connect(mapStateToProps,mapDispatchToProps)(ChangePassword);